<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <h4 class="card-title text-left">&nbsp;</h4>
            <base-button class="update-button" @click.prevent="addQuest" type="success">퀘스트추가</base-button>
          </div>
          <div class="col-sm-6" v-if="viewType === 'artist'">
            <ArtistSelect @unitChangeEvent="getArtistInfo" :is-filter="true" :show-members="false" :initial-unit-id="parseInt($route.query.unitId, 10)" />
          </div>
          <div class="col-sm-6" v-else>
            <div class="row">
              <div class="col-sm-6">
                <h4 class="card-title text-left">하루제한 포인트</h4>
                <base-input placeholder="포인트" v-model="point"></base-input>
              </div>
              <div class="col-sm-2">
                <h4 class="card-title text-left">&nbsp;</h4>
                <base-button class="update-button" @click.prevent="setQuestPointPerDay" type="success">저장</base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="row">
          <div class="col-sm-2">
            <h4 class="card-title text-left">&nbsp;</h4>
          </div>
          <div class="col-sm-10"></div>
        </div>
        <base-radio name="common" inline v-model="viewType">공통</base-radio>
        <base-radio name="artist" inline v-model="viewType">아티스트</base-radio><br />
      </div>
    </div>

    <div class="quest-tabs mb-3">
      <div
        class="quest-tab"
        v-for="category in categories"
        :key="category.id"
        :class="{ 'active-tab': categoryId === category.id }"
        @click="getQuestsByCategoryId(category.id)"
      >
        {{ category.title }}
      </div>
    </div>

    <div class="mb-3 d-flex align-items-center">
      <el-button
        v-for="option in ['전체', '활성', '비활성', '추후노출']"
        :key="option"
        :type="questFilter === option ? 'primary' : 'default'"
        size="mini"
        class="mr-2"
        @click="questFilter = option"
      >
        {{ option }}
      </el-button>
    </div>

    <div class="table-scroll">
      <el-table :data="filteredData" border>
        <el-table-column prop="id" label="ID" header-align="center" align="center" width="50" />
        <el-table-column prop="name" label="퀘스트명" header-align="center" width="500" />
        <el-table-column label="상태" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.weight === 0 || (scope.row.endTime && new Date(scope.row.endTime) < new Date())" style="color: gray">비활성</span>
            <span v-else-if="scope.row.startTime && new Date(scope.row.startTime) > new Date()" style="color: orange">추후노출</span>
            <span v-else style="color: green">활성</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="가중치" header-align="center" align="center" width="100" />
        <el-table-column prop="point" label="포인트" header-align="center" align="center" width="100" />
        <el-table-column label="작업" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button size="mini" type="warning" @click="goQuestForm(scope.row.id)">상세</el-button>
              <el-button size="mini" type="warning" @click="copyQuest(scope.row.id)">복사</el-button>
              <el-button size="mini" type="danger" @click="deleteQuest(scope.row.id)">삭제</el-button>
              <el-button
                v-if="
                  scope.row.weight > 0 &&
                  (!scope.row.startTime || new Date(scope.row.startTime) <= new Date()) &&
                  (!scope.row.endTime || new Date(scope.row.endTime) >= new Date())
                "
                size="mini"
                type="danger"
                @click="sendNotification(scope.row.id)"
              >
                알림전송
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";
import { BaseInput, Card } from "@/components/index";
import swal from "sweetalert2";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import * as _ from "lodash";

export default {
  components: {
    Card,
    ArtistSelect,
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  async created() {
    if (this.$route.query.viewType) {
      this.viewType = this.$route.query.viewType;
    }
    await this.getCategories();
    await this.getData();
  },
  data() {
    return {
      unitId: null,
      viewType: "common",
      categoryId: null,
      categories: [],
      data: [],
      point: 0,
      questsByLevel: [],
      questFilter: "전체",
    };
  },
  computed: {
    filteredData() {
      const now = new Date();
      return this.data.filter((quest) => {
        if (this.questFilter === "전체") return true;
        if (this.questFilter === "활성") {
          return quest.weight > 0 && (!quest.startTime || new Date(quest.startTime) <= now) && (!quest.endTime || new Date(quest.endTime) >= now);
        }
        if (this.questFilter === "추후노출") {
          return quest.weight > 0 && quest.startTime && new Date(quest.startTime) > now;
        }
        if (this.questFilter === "비활성") {
          return quest.weight === 0 || (quest.endTime && new Date(quest.endTime) < now);
        }
        return true;
      });
    },
  },
  watch: {
    viewType: {
      async handler() {
        try {
          await this.$router.push(`/quest?viewType=${this.viewType}`);
        } catch (ex) {}
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      await this.getData();
    },
    copyQuest(questId) {
      const quest = _.find(this.data, { id: questId });
      const dom = document.createElement("textarea");
      document.body.appendChild(dom);
      dom.value = JSON.stringify(quest);
      dom.select();
      document.execCommand("copy");
      document.body.removeChild(dom);
      window.Toast.success("클립보드에 퀘스트가 복사되었습니다");
    },
    async getQuestsByCategoryId(categoryId) {
      this.categoryId = categoryId;
      await this.getData();
    },
    async getCategories() {
      const res = await this.$axios.get(`/quests/categories?unitId=${this.unitId}`);
      this.categories = [{ id: null, title: "전체" }, ...res.data.data, { id: 0, title: "미할당" }];
    },
    async getData() {
      let res;
      if (this.viewType === "artist") {
        res = await this.$axios.get(`/quests?unitId=${this.unitId}&categoryId=${this.categoryId}`);
      } else {
        await this.getQuestPointPerDay();
        res = await this.$axios.get(`/quests?categoryId=${this.categoryId}`);
      }
      this.data = res.data.data;
    },
    async addQuest() {
      const res = await this.$axios.post(`/quests`, { unitId: this.unitId });

      this.goQuestForm(res.data.data);
    },
    async sendNotification(questId) {
      swal
        .fire({
          title: "알림 전송 확인",
          html: `
      <div>
        <input type="text" id="titleKo" class="swal2-input" placeholder="알림타이틀(한국어)">
        <input type="text" id="bodyKo" class="swal2-input" placeholder="알림내용(한국어)">
        <input type="text" id="titleEn" class="swal2-input" placeholder="알림타이틀(영어)">
        <input type="text" id="bodyEn" class="swal2-input" placeholder="알림내용(영어)">
        <input type="text" id="titleJa" class="swal2-input" placeholder="알림타이틀(일본어)">
        <input type="text" id="bodyJa" class="swal2-input" placeholder="알림내용(일본어)">
      </div>
    `,
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
          preConfirm: () => {
            // 입력값을 가져와서 객체로 반환
            const titleKo = document.getElementById("titleKo").value;
            const bodyKo = document.getElementById("bodyKo").value;
            const titleEn = document.getElementById("titleEn").value;
            const bodyEn = document.getElementById("bodyEn").value;
            const titleJa = document.getElementById("titleJa").value;
            const bodyJa = document.getElementById("bodyJa").value;

            if (!titleKo || !bodyKo || !titleEn || !bodyEn || !titleJa || !bodyJa) {
              swal.showValidationMessage("모든 입력값을 채워주세요.");
              return false;
            }

            return { titleKo, bodyKo, titleEn, bodyEn, titleJa, bodyJa };
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              return this.$axios
                .put(`/quests/${questId}/notification`, {
                  unitId: this.unitId,
                  ...result.value,
                })
                .then((res) => {
                  Toast.success("전송완료");
                });
            } catch (err) {
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async deleteQuest(questId) {
      swal
        .fire({
          title: "퀘스트 삭제 확인",
          text: "정말로 이 퀘스트를 삭제하시겠습니까?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            await this.$axios.delete(`/quests`, { params: { unitId: this.unitId, questId } });
            await this.getData();
          }
        });
    },
    goQuestForm(id) {
      let path = `/quest/questForm?id=${id}`;
      if (this.unitId) {
        path += `&unitId=${this.unitId}`;
      }
      this.$router.push(path);
    },
    async setQuestPointPerDay() {
      swal
        .fire({
          title: "하루 제한 포인트 설정",
          text: "입력한 포인트로 설정하시겠습니까?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "등록",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            return this.$axios.put("/common/config", { key: "QUEST_MAX_POINT", value: this.point }).then((res) => {
              window.Toast.success(`포인트 정보가 등록되었습니다`);
            });
          }
        });
    },
    async getQuestPointPerDay() {
      const res = await this.$axios.get(`/common/config?key=QUEST_MAX_POINT`);
      this.point = res.data.data;
    },
  },
};
</script>
<style scoped>
tr {
  cursor: pointer;
}
.template-table {
  margin-bottom: 15px;
}
.base-button.active {
  background-color: #007bff;
  color: white;
}
.quest-tabs {
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
}
.quest-tab {
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  margin-right: 10px;
}
.quest-tab.active-tab {
  border-bottom: 3px solid #007bff;
  color: #007bff;
}
.table-scroll {
  overflow-x: auto;
}
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}
</style>
